import React, { FC } from 'react'
import { Button as CosmaButton } from 'is24-corecss'
import './Button.scss'
import { useSelector } from 'react-redux'
import { IntegrationType } from '../../@types/config'
import { ReduxState } from '../../store/reducers'

type ButtonProps = {
  onClick: () => unknown
  text: string
  className?: string
  dataTesting?: string
}

export const Button: FC<ButtonProps> = (props) => {
  const integrationType = useSelector((state: ReduxState) => state.config.integrationType)
  const isIv24Integration = integrationType === IntegrationType.IMMOVERKAUF24

  return (
    <CosmaButton
      className={`font-s font-normal  ${isIv24Integration ? `oval-button-iv24` : `oval-button`} ${
        props.className
      } padding-horizontal-l`}
      onClick={props.onClick}
      data-testing={props.dataTesting}
    >
      {props.text}
    </CosmaButton>
  )
}

export default Button
